import * as TK from 'components/post/Reactions/translations/constants';
import { Translations } from 'translations/types';

export const reactionsEnUsLocale: Translations = {
  [TK.REACTIONS_REACTION]: 'reaction',
};
